<div>
  <form class="example-form" #f="ngForm">
    <mat-card class="example-card " style="height: 300px">
      <mat-card-content>
         <!------------ bare de chargement ----------------->
         <div *ngIf="exist;else attente"></div>
         <ng-template #attente>
           <mat-progress-bar mode="indeterminate"></mat-progress-bar>
         </ng-template>
        <!------------ bouton ----------------->
        <div class="btn" >
          <div class="button-row">
              <button (click)="enregistrer(f)" [disabled]="dsabledBtnEnregister" type="submit"  mat-raised-button
            class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
          </div>   
          <div class="button-row">
            <button (click)="close()" mat-raised-button class="colorRed"><mat-icon>close</mat-icon>Fermer</button>
          </div>  
        </div>
        <!-- ------------------------form alert--------------------------  -->
        <mat-form-field     appearance="outline"  style="margin-right: 10px;width:150px" class="example-full-width">
          <mat-label>Date alerte</mat-label>
          <input matInput name="avtAlerte_Date" #avtAlerte_Date="ngModel" [(ngModel)]="alert.avtAlerte_Date" [matDatepicker]="alertDate" placeholder="Date alerte" required>
          <mat-datepicker-toggle matSuffix [for]="alertDate"></mat-datepicker-toggle>
          <mat-datepicker #alertDate></mat-datepicker>
        </mat-form-field>
        
        <mat-form-field  style="margin-right: 10px;"   appearance="outline"  *ngIf="data.type == 'client'">
          <mat-label>Interlocuteur</mat-label>
          <mat-select name="avtAlerteInterlocuteur" #avtAlerteInterlocuteur="ngModel" required [(ngModel)]="alert.TiersC_Id" placeholder="Interlocuteur">
            <mat-option *ngFor="let c of datasourceInterlocuteur" [value]="c.TiersC_Id">{{c.TiersC_Nom}} {{c.TiersC_PreNom}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-select style="width: 150px;" name="avtAlerte_Statut" #avtAlerte_Statut="ngModel" [(ngModel)]="alert.avtAlerte_Statut" placeholder="Statut">
              <mat-option  *ngFor="let statut of listeStatut" [value]="statut.value">
                {{ statut.text }}
              </mat-option>
          </mat-select>

        </mat-form-field >
        <app-editor [id]="'editot-text1'" (outputAction)="editorAction($event)"  #editor [config]="configInfoBasPage"></app-editor>
        <!-- Angular Editor Supprimer -->
        <!-- <angular-editor [config]="editorConfig" name="avtAlerte_Texte" placeholder=" " #avtAlerte_Texte="ngModel" [(ngModel)]="alert.avtAlerte_Texte"></angular-editor>     -->
      </mat-card-content>
    </mat-card>
  </form>
</div>